import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import fontpage from "../../images/fontpage.jpg";
import logocdac from "../../images/cdac-alt.jpg";
import title from "../../images/Diginyay-transparent.png";
import logo from "../../images/main-logo.png";
import front from "../../images/FRONTPAGES/CDAC FRONT SENTIMENT.png";

import {
  countPlatforms,
  countSections,
  countSentiment,
  countLanguages,
  addFontsToPDF,
} from "./Pdfhelper";

export const PrintSentimentReport = async (
  serverresponse,
  pieChartRef,
  sectionPieChartRef,
  sentimentPieChartRef,
  selectedPlatforms,
  barChartRef,
  wordCloudRef,
  setIsCompleted,
  setIsLoading,
  pdfToSimple,
  pdfFromSimple,
  sentimentSummary
) => {
  setIsLoading(true); // Show loading indicator

  // Normalize sentimentSummary if it's an array
  if (Array.isArray(sentimentSummary) && sentimentSummary.length > 0) {
    sentimentSummary = sentimentSummary[0];
  }

  try {
    const pdf = new jsPDF("p", "mm", "a4");

    // Function to add background image
    const addBackgroundImage = (pdfInstance) => {
      const imgWidth = pdfInstance.internal.pageSize.getWidth();
      const imgHeight = pdfInstance.internal.pageSize.getHeight();
      pdfInstance.addImage(fontpage, "JPEG", 0, 0, imgWidth, imgHeight);
    };

    // Add background image to the first page
    const imgWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = pdf.internal.pageSize.getHeight();
    pdf.addImage(front, "JPEG", 0, 0, imgWidth, imgHeight);

    const titleImgWidth = 100; // Set your title image width
    const titleImgHeight = 30; // Set your title image height
    const pageWidth = pdf.internal.pageSize.getWidth();
    const titleImgX = (pageWidth - titleImgWidth) / 2;
    const titleImgY = 50; // Set the desired Y position of the title image

    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(26);

    if (pdfToSimple) {
      pdf.setFont(undefined, "bold");
      pdf.text(`  ${pdfToSimple}`, 41, 213);
    }

    // Add this function to render sentiment summary template in the second page

    const renderSentimentSummaryTemplate = (
      pdf,
      sentimentSummary,
      yPosition = 15
    ) => {
      const pageWidth = pdf.internal.pageSize.getWidth();
      const halfPageHeight = pdf.internal.pageSize.getHeight() / 2;

      // Template background with subtle border
      pdf.setDrawColor(200, 200, 200);
      pdf.setFillColor(248, 249, 250); // Light gray background
      pdf.roundedRect(
        10,
        yPosition,
        pageWidth - 20,
        halfPageHeight - 25,
        3,
        3,
        "FD"
      );

      let currentY = yPosition + 12;

      // Main Title
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(12);
      pdf.setTextColor(52, 58, 64); // Dark gray
      pdf.text("SENTIMENT ANALYSIS INSIGHTS", pageWidth / 2, currentY, {
        align: "center",
      });

      currentY += 10;
      if (sentimentSummary.is_session_shared === true) {
        const columnWidth = (pageWidth - 40) * 0.72; // 72% of available width for medium size
        const columnX = (pageWidth - columnWidth) / 2; // Center the column

        // Single column header
        pdf.setFontSize(10);
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(37, 99, 235);
        pdf.text("MIXED SENTIMENT SESSION", pageWidth / 2, currentY, {
          align: "center",
        });

        currentY += 8;

        // Mixed sentiment session details
        if (sentimentSummary.mixed_sentiment_session) {
          const mixedSession = sentimentSummary.mixed_sentiment_session;

          // Mixed session details box
          pdf.setDrawColor(37, 99, 235); // Blue border
          pdf.setFillColor(239, 246, 255);
          pdf.roundedRect(columnX, currentY, columnWidth, 45, 2, 2, "FD");

          pdf.setFont("helvetica", "normal");
          pdf.setFontSize(10);
          pdf.setTextColor(33, 37, 41);

          // Professional layout with proper spacing and alignment
          const fieldSpacing = 10;
          const labelColor = [0, 0, 0];
          const valueColor = [33, 37, 41];

          // Row 1: Keyword and Session ID
          let rowY = currentY + 10;

          // Keyword (left side)
          pdf.setFont("helvetica", "bold");
          pdf.setTextColor(...labelColor);
          pdf.text("Keyword:", columnX + 10, rowY);

          pdf.setFont("helvetica", "normal");
          pdf.setTextColor(...valueColor);
          pdf.text(mixedSession.keyword, columnX + 30, rowY);

          // Session ID (right side)
          const rightStartX = columnX + columnWidth / 2 + 10;
          pdf.setFont("helvetica", "bold");
          pdf.setTextColor(...labelColor);
          pdf.text("Session ID:", rightStartX, rowY);

          pdf.setFont("helvetica", "normal");

          pdf.setTextColor(...valueColor);

          const sessionIdX = rightStartX + 22;
          const sessionIdMaxWidth = columnX + columnWidth - sessionIdX - 8; // keep inside box

          const sessionIdLines = pdf.splitTextToSize(
            mixedSession.session_id || "N/A",
            sessionIdMaxWidth
          );

          pdf.text(sessionIdLines, sessionIdX, rowY);

          // Row 2: Positive and Negative Scores
          rowY += fieldSpacing;

          // Positive Score (left side)
          pdf.setFont("helvetica", "bold");
          pdf.setTextColor(...labelColor);
          pdf.text("Positive:", columnX + 10, rowY);

          pdf.setFont("helvetica", "normal");
          pdf.setTextColor(...valueColor);
          pdf.text(
            `${((mixedSession.avg_positive_score || 0) * 100).toFixed(2)}%`,
            columnX + 30,
            rowY
          );

          // Negative Score (right side)
          pdf.setFont("helvetica", "bold");
          pdf.setTextColor(...labelColor);
          pdf.text("Negative:", rightStartX, rowY);

          pdf.setFont("helvetica", "normal");
          pdf.setTextColor(...valueColor);
          pdf.text(
            `${((mixedSession.avg_negative_score || 0) * 100).toFixed(2)}%`,
            rightStartX + 20,
            rowY
          );

          // Row 3: Neutral Score and Posts Count
          rowY += fieldSpacing;

          // Neutral Score (left side)
          pdf.setFont("helvetica", "bold");
          pdf.setTextColor(...labelColor);
          pdf.text("Neutral:", columnX + 10, rowY);

          pdf.setFont("helvetica", "normal");
          pdf.setTextColor(...valueColor);
          pdf.text(
            `${((mixedSession.avg_neutral_score || 0) * 100).toFixed(2)}%`,
            columnX + 30,
            rowY
          );

          // Posts Count (right side)
          pdf.setFont("helvetica", "bold");
          pdf.setTextColor(...labelColor);
          pdf.text("Posts:", rightStartX, rowY);

          pdf.setFont("helvetica", "normal");
          pdf.setTextColor(...valueColor);
          pdf.text(
            `${mixedSession.total_posts || "N/A"}`,
            rightStartX + 17,
            rowY
          );
        }

        currentY += 55;
      } else if (sentimentSummary.is_session_shared === false) {
        // Two column layout for separate sessions (original code)
        const leftColumnX = 20;
        const rightColumnX = pageWidth / 2 + 5;
        const columnWidth = (pageWidth - 40) / 2;

        // Column headers
        pdf.setFontSize(10);
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(220, 53, 69); // Red color

        pdf.text(
          "MOST NEGATIVE KEYWORD",
          leftColumnX + (columnWidth - 10) / 2,
          currentY,
          { align: "center" }
        );

        pdf.setTextColor(40, 167, 69); // Green color

        pdf.text(
          "MOST POSITIVE KEYWORD",
          rightColumnX + (columnWidth - 10) / 2,
          currentY,
          { align: "center" }
        );
        currentY += 5;

        // Left Column - Most Negative Session
        if (sentimentSummary.highest_avg_negative_session) {
          const negSession = sentimentSummary.highest_avg_negative_session;

          // Negative session details box
          pdf.setDrawColor(220, 53, 69);
          pdf.setFillColor(255, 245, 245); // Light red background
          pdf.roundedRect(
            leftColumnX,
            currentY,
            columnWidth - 10,
            40,
            2,
            2,
            "FD"
          );

          pdf.setFont("helvetica", "normal");
          pdf.setFontSize(10);
          pdf.setTextColor(33, 37, 41);

          // Session details with proper spacing
          const negDetails = [
            `Keyword: ${negSession.keyword}`,
            `Session ID: ${negSession.session_id}`,
            `Negative Score: ${(
              (negSession.avg_negative_score || 0) * 100
            ).toFixed(2)}%`,
            `Positive Score: ${(
              (negSession.avg_positive_score || 0) * 100
            ).toFixed(2)}%`,
            // `Posts Count: ${negSession.total_posts || "N/A"}`,
          ];

          negDetails.forEach((detail, index) => {
            pdf.text(detail, leftColumnX + 5, currentY + 8 + index * 7);
          });
        }

        // Right Column - Most Positive Session
        if (sentimentSummary.highest_avg_positive_session) {
          const posSession = sentimentSummary.highest_avg_positive_session;

          // Positive session details box
          pdf.setDrawColor(40, 167, 69);
          pdf.setFillColor(240, 248, 245); // Light green background
          pdf.roundedRect(
            rightColumnX,
            currentY,
            columnWidth - 10,
            40,
            2,
            2,
            "FD"
          );

          pdf.setFont("helvetica", "normal");
          pdf.setFontSize(10);
          pdf.setTextColor(33, 37, 41);

          // Session details with proper spacing
          const posDetails = [
            `Keyword: ${posSession.keyword}`,
            `Session ID: ${posSession.session_id}`,
            `Positive Score: ${(
              (posSession.avg_positive_score || 0) * 100
            ).toFixed(2)}%`,
            `Negative Score: ${(
              (posSession.avg_negative_score || 0) * 100
            ).toFixed(2)}%`,
            // `Posts Count: ${posSession.total_posts || "N/A"}`,
          ];

          posDetails.forEach((detail, index) => {
            pdf.text(detail, rightColumnX + 5, currentY + 10 + index * 7);
          });
        }

        currentY += 50;
      } else {
        // Handle case when is_session_shared is not present
        const columnWidth = (pageWidth - 40) * 0.72; // 72% of available width for medium size
        const columnX = (pageWidth - columnWidth) / 2; // Center the column

        // Single column header
        pdf.setFontSize(10);
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(37, 99, 235);
        pdf.text("SINGLE SESSION ANALYSIS", pageWidth / 2, currentY, {
          align: "center",
        });
        currentY += 8;

        // Single session details box
        pdf.setDrawColor(37, 99, 235); // Blue border
        pdf.setFillColor(239, 246, 255);
        pdf.roundedRect(columnX, currentY, columnWidth, 35, 2, 2, "FD");

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(10);
        pdf.setTextColor(33, 37, 41);

        // Professional layout with proper spacing and alignment
        const fieldSpacing = 10;
        const labelColor = [0, 0, 0];
        const valueColor = [33, 37, 41];

        // Row 1: Keyword and Session ID
        let rowY = currentY + 10;

        // Keyword (left side)
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(...labelColor);
        pdf.text("Keyword:", columnX + 10, rowY);

        pdf.setFont("helvetica", "normal");
        pdf.setTextColor(...valueColor);
        pdf.text(sentimentSummary.keyword || "N/A", columnX + 30, rowY);

        // Session ID (right side)
        const rightStartX = columnX + columnWidth / 2 + 10;
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(...labelColor);
        pdf.text("Session ID:", rightStartX, rowY);

        pdf.setFont("helvetica", "normal");
        pdf.setTextColor(...valueColor);
        pdf.text(sentimentSummary.session_id || "N/A", rightStartX + 22, rowY);

        // Row 2: Normalized Score
        rowY += fieldSpacing;

        // Normalized Score (centered)
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(...labelColor);
        pdf.text("Score:", columnX + 10, rowY);

        pdf.setFont("helvetica", "normal");
        pdf.setTextColor(...valueColor);
        pdf.text(
          `${((sentimentSummary.normalized_score || 0) * 100).toFixed(4)}%`,
          columnX + 30,
          rowY
        );

        currentY += 45;
      }

      // Summary Section
      if (sentimentSummary.summary) {
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(12);
        pdf.setTextColor(23, 162, 184); // Bootstrap info color
        pdf.text("ANALYSIS SUMMARY", pageWidth / 2, currentY, {
          align: "center",
        });

        currentY += 5;

        // Summary box
        pdf.setDrawColor(23, 162, 184);
        pdf.setFillColor(240, 249, 252); // Light blue background
        pdf.roundedRect(15, currentY, pageWidth - 30, 30, 2, 2, "FD");

        // Format and display summary text
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(8);
        pdf.setTextColor(33, 37, 41);

        const summaryLines = pdf.splitTextToSize(
          sentimentSummary.summary,
          pageWidth - 40
        );
        const maxLines = 4; // Limit to 4 lines to fit in half page
        const displayLines = summaryLines.slice(0, maxLines);

        displayLines.forEach((line, index) => {
          pdf.text(line, 20, currentY + 8 + index * 6);
        });

        if (summaryLines.length > maxLines) {
          pdf.setFont("helvetica", "italic");
          pdf.setFontSize(7);
          pdf.text("...", pageWidth - 25, currentY + 8 + maxLines * 6);
        }
      }

      return halfPageHeight; // Return the Y position for next content
    };

    if (sentimentPieChartRef.current) {
      pdf.addPage();
      addBackgroundImage(pdf);

      // First, render the sentiment summary template in the upper half
      const nextYPosition = renderSentimentSummaryTemplate(
        pdf,
        sentimentSummary,
        37
      );

      // Then add the sentiment pie chart in the lower half
      const sentimentPieChartCanvas = await html2canvas(
        sentimentPieChartRef.current
      );
      const sentimentPieChartImage =
        sentimentPieChartCanvas.toDataURL("image/jpeg");

      // Use the same dimensions and positioning as the previous code
      const imgWidth = 295;
      const aspectRatio =
        sentimentPieChartCanvas.width / sentimentPieChartCanvas.height;
      const imgHeight = imgWidth / aspectRatio;

      // Calculate starting x-coordinate to center the pie chart horizontally
      const startX = (pdf.internal.pageSize.getWidth() - imgWidth) / 2;

      // Position the chart in the lower half, but maintain original sizing
      const chartStartY = nextYPosition + 25;

      pdf.addImage(
        sentimentPieChartImage,
        "JPEG",
        startX,
        chartStartY,
        imgWidth,
        imgHeight
      );

      // Add sentiment counts with the same format as previous code
      const sentimentCounts = countSentiment(serverresponse);
      let sentimentCountText = "\n";
      for (const sentiment in sentimentCounts) {
        sentimentCountText += `${sentiment}: ${sentimentCounts[sentiment]}, `;
      }
      const wrappedSentimentCountText = pdf.splitTextToSize(
        sentimentCountText,
        pdf.internal.pageSize.getWidth() - 20
      );

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(0, 123, 255); // #007bff color for Sentiment Counts heading
      pdf.text("Sentiment Count:", 10, chartStartY + imgHeight + 10);

      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      pdf.text(wrappedSentimentCountText, 10, chartStartY + imgHeight + 10);
    } else {
      console.error("Sentiment pie chart reference not found or not rendered.");
    }

    // Add a third page for the word cloud and bar chart
    if (barChartRef.current) {
      pdf.addPage();
      addBackgroundImage(pdf);
      const topMargin = 3;
      const bottomMargin = 30;

      // Draw white background rectangle for bar chart with space from top and bottom
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const usableHeight = pageHeight - topMargin - bottomMargin;
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, topMargin, pageWidth, usableHeight, "F");

      // Draw bar chart
      const barChartCanvas = await html2canvas(barChartRef.current);
      const barChartImage = barChartCanvas.toDataURL("image/jpeg");

      const barChartWidth = pageWidth - 30; // full width with padding
      const barChartAspectRatio = barChartCanvas.width / barChartCanvas.height;
      const barChartHeight = barChartWidth / barChartAspectRatio;

      const barChartStartX = (pageWidth - barChartWidth) / 2;
      const barChartStartY = topMargin + 10;

      // Draw bar chart
      pdf.addImage(
        barChartImage,
        "JPEG",
        barChartStartX,
        barChartStartY,
        barChartWidth,
        barChartHeight
      );

      const languagesCounts = countPlatforms(serverresponse);
      let platformCountText = "Platform Counts:\n";
      for (const platform in languagesCounts) {
        platformCountText += `${platform}: ${languagesCounts[platform]}, `;
      }
      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      pdf.text(platformCountText, 10, barChartHeight + 20);

      if (wordCloudRef.current) {
        const wordCloudCanvas = await html2canvas(wordCloudRef.current);
        const wordCloudImage = wordCloudCanvas.toDataURL("image/jpeg");

        // Set a specific width for the word cloud image
        const wordCloudWidth = 200;
        const wordCloudAspectRatio =
          wordCloudCanvas.width / wordCloudCanvas.height;
        const wordCloudHeight = wordCloudWidth / wordCloudAspectRatio;

        const wordCloudStartX = (pageWidth - wordCloudWidth) / 2;
        const wordCloudStartY = barChartStartY + barChartHeight + 25;

        pdf.addImage(
          wordCloudImage,
          "JPEG",
          wordCloudStartX,
          wordCloudStartY,
          wordCloudWidth,
          wordCloudHeight
        );
      }
    } else {
      console.error("Bar chart reference not found or not rendered.");
    }

    // Start table from the next page
    pdf.addPage();

    const tableData = serverresponse;

    if (!tableData || tableData.length === 0) {
      console.error("No data available to print");
      return;
    }

    const tableColumnHeaders = [
      "S.No",
      "UserName",
      "Keywords",
      "Sentiment",
      "Platform",
      "Content",
    ];

    const tableRows = tableData
      .filter((data) => data.languages !== "none")
      .map((data, index) => {
        const truncateContent = (content, wordLimit) => {
          if (typeof content !== "string") {
            return "N/A";
          }
          const words = content.split(" ");
          if (words.length > wordLimit) {
            return words.slice(0, wordLimit).join(" ") + "...";
          }
          return content;
        };

        return [
          String(index + 1),
          data.userId ? String(data.userId) : String(data.postOwner || "N/A"),
          String(data.keywords || data.keyword || "N/A"),

          String(data.analysis?.prediction || data.sentiment || "N/A"),
          String(data.platform || "N/A"),
          {
            content:
              data.platform === "youtube"
                ? truncateContent(data.content[0].title, 40)
                : truncateContent(data.content, 40) || "N/A",
            link: data.link,
          },
        ];
      });

    pdf.autoTable({
      head: [tableColumnHeaders],
      body: tableRows,
      startY: 10,
      tableWidth: "auto",
      styles: {
        cellPadding: 2,
        fontSize: 10,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [0, 0, 0],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      bodyStyles: {
        textColor: [0, 0, 0],
      },
      alternateRowStyles: {
        fillColor: [227, 242, 253],
      },
      columnStyles: {
        0: { cellWidth: 15 },
        1: { cellWidth: 30 },
        2: { cellWidth: 35 },
        3: { cellWidth: 25 }, // Sentiment
        4: { cellWidth: 25 }, // Platform
        5: { cellWidth: "auto" }, // Content (increased width)
      },

      margin: { top: 1, left: 1, right: 1, bottom: 1 },

      didParseCell: function (data) {
        if (data.column.index === 5 && data.cell.section === "body") {
          data.cell.styles.cellPadding = 2;
        }
      },

      didDrawCell: function (data) {
        if (data.cell.section === "body" && data.cell.raw) {
          const cell = data.cell;
          const pdfDoc = data.doc;
          const cellWidth =
            cell.width - cell.padding("left") - cell.padding("right");
          const textPos = {
            x: cell.x + cell.padding("left"),
            y: cell.y + cell.padding("top") + 2,
          };

          if (data.column.index === 1 && cell.raw) {
            pdfDoc.setFontSize(10);
            pdfDoc.setTextColor(0, 0, 0);
            const splitText = pdfDoc.splitTextToSize(cell.raw, cellWidth);
            const lineSpacing = 4;

            splitText.forEach((line, index) => {
              let fontForThisLine = "NotoSans"; // Default font

              if (/\p{Script=Devanagari}/u.test(line)) {
                addFontsToPDF(pdf, "Hindi");
                fontForThisLine = "NotoSans";
              } else if (/\p{Script=Tamil}/u.test(line)) {
                addFontsToPDF(pdf, "Tamil");
                fontForThisLine = "NotoSansTamil";
              } else if (/\p{Script=Gujarati}/u.test(line)) {
                addFontsToPDF(pdf, "Gujarati");
                fontForThisLine = "NotoSansGujarati";
              } else if (/\p{Script=Bengali}/u.test(line)) {
                addFontsToPDF(pdf, "Bengali");
                fontForThisLine = "NotoSansBengali";
              } else if (/\p{Script=Gurmukhi}/u.test(line)) {
                addFontsToPDF(pdf, "Punjabi");
                fontForThisLine = "NotoSansGurmukhi"; // For Punjabi (Gurmukhi script)
              } else if (/\p{Script=Arabic}/u.test(line)) {
                addFontsToPDF(pdf, "Urdu");
                fontForThisLine = "NotoSansArabic";
              } else if (/\p{Script=Malayalam}/u.test(line)) {
                addFontsToPDF(pdf, "Malayalam");
                fontForThisLine = "NotoSansMalayalam";
              } else if (/\p{Script=Oriya}/u.test(line)) {
                addFontsToPDF(pdf, "Oriya");
                fontForThisLine = "NotoSansOriya";
              } else if (/\p{Script=Kannada}/u.test(line)) {
                addFontsToPDF(pdf, "Kannada");
                fontForThisLine = "NotoSerifKannada";
              }

              pdf.setFont(fontForThisLine);
              pdfDoc.text(line, textPos.x, textPos.y + index * lineSpacing);
            });
          }

          // Handle Keywords column (index 2) with multilingual support
          if (data.column.index === 2 && cell.raw) {
            pdfDoc.setFontSize(10);
            pdfDoc.setTextColor(0, 0, 0);
            const splitText = pdfDoc.splitTextToSize(cell.raw, cellWidth);
            const lineSpacing = 4;
            splitText.forEach((line, index) => {
              let fontForThisLine = "NotoSans"; // Default font

              if (/\p{Script=Devanagari}/u.test(line)) {
                addFontsToPDF(pdf, "Hindi");
                fontForThisLine = "NotoSans";
              } else if (/\p{Script=Tamil}/u.test(line)) {
                addFontsToPDF(pdf, "Tamil");
                fontForThisLine = "NotoSansTamil";
              } else if (/\p{Script=Gujarati}/u.test(line)) {
                addFontsToPDF(pdf, "Gujarati");
                fontForThisLine = "NotoSansGujarati";
              } else if (/\p{Script=Oriya}/u.test(line)) {
                addFontsToPDF(pdf, "Oriya");
                fontForThisLine = "NotoSansOriya";
              } else if (/\p{Script=Bengali}/u.test(line)) {
                addFontsToPDF(pdf, "Bengali");
                fontForThisLine = "NotoSansBengali";
              } else if (/\p{Script=Gurmukhi}/u.test(line)) {
                addFontsToPDF(pdf, "Punjabi");
                fontForThisLine = "NotoSansGurmukhi"; // For Punjabi (Gurmukhi script)
              } else if (/\p{Script=Arabic}/u.test(line)) {
                addFontsToPDF(pdf, "Urdu");
                fontForThisLine = "NotoSansArabic";
              } else if (/\p{Script=Malayalam}/u.test(line)) {
                addFontsToPDF(pdf, "Malayalam");
                fontForThisLine = "NotoSansMalayalam";
              } else if (/\p{Script=Kannada}/u.test(line)) {
                addFontsToPDF(pdf, "Kannada");
                fontForThisLine = "NotoSerifKannada";
              }
              pdf.setFont(fontForThisLine);
              pdfDoc.text(line, textPos.x, textPos.y + index * lineSpacing);
            });
          }

          if (data.column.index === 5 && cell.raw.link) {
            pdfDoc.setFontSize(10);
            pdfDoc.setTextColor(0, 0, 0);
            const splitText = pdfDoc.splitTextToSize(
              cell.raw.content,
              cellWidth
            );
            const lineSpacing = 4;

            splitText.forEach((line, index) => {
              let fontForThisLine = "NotoSans"; // Default font

              if (/\p{Script=Devanagari}/u.test(line)) {
                addFontsToPDF(pdf, "Hindi");
                fontForThisLine = "NotoSans";
              } else if (/\p{Script=Oriya}/u.test(line)) {
                addFontsToPDF(pdf, "Oriya");
                fontForThisLine = "NotoSansOriya";
              } else if (/\p{Script=Gujarati}/u.test(line)) {
                addFontsToPDF(pdf, "Gujarati");
                fontForThisLine = "NotoSansGujarati";
              } else if (/\p{Script=Tamil}/u.test(line)) {
                addFontsToPDF(pdf, "Tamil");
                fontForThisLine = "NotoSansTamil";
              } else if (/\p{Script=Bengali}/u.test(line)) {
                addFontsToPDF(pdf, "Bengali");
                fontForThisLine = "NotoSansBengali";
              } else if (/\p{Script=Gurmukhi}/u.test(line)) {
                addFontsToPDF(pdf, "Punjabi");
                fontForThisLine = "NotoSansGurmukhi"; // For Punjabi (Gurmukhi script)
              } else if (/\p{Script=Arabic}/u.test(line)) {
                addFontsToPDF(pdf, "Urdu");
                fontForThisLine = "NotoSansArabic";
              } else if (/\p{Script=Malayalam}/u.test(line)) {
                addFontsToPDF(pdf, "Malayalam");
                fontForThisLine = "NotoSansMalayalam";
              } else if (/\p{Script=Kannada}/u.test(line)) {
                addFontsToPDF(pdf, "Kannada");
                fontForThisLine = "NotoSerifKannada";
              }
              pdf.setFont(fontForThisLine);

              pdfDoc.textWithLink(
                line,
                textPos.x,
                textPos.y + index * lineSpacing,
                { url: cell.raw.link }
              );
            });
          }
        }
      },

      willDrawCell: function (data) {
        if (
          data.column.index === 5 &&
          data.cell.section === "body" &&
          data.cell.raw
        ) {
          const cell = data.cell;
          cell.text = "";
        }

        if (
          data.column.index === 1 &&
          data.cell.section === "body" &&
          data.cell.raw
        ) {
          const cell = data.cell;
          cell.text = "";
        }

        if (
          data.column.index === 2 &&
          data.cell.section === "body" &&
          data.cell.raw
        ) {
          const cell = data.cell;
          cell.text = "";
        }
      },

      rowPageBreak: "avoid",
    });

    const platformLabels =
      selectedPlatforms.length === 0
        ? "Consolidated"
        : selectedPlatforms[0].label;
    if (pdfToSimple) {
      pdf.save(
        `CSMART_${platformLabels}_Social_Media_Report_${pdfToSimple}.pdf`
      );
      setIsCompleted(true);
    } else {
      pdf.save(`CSMART_${platformLabels}_Report.pdf`);
      setIsCompleted(true);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
  setIsLoading(false);
};
